import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Divider, Grid, TextField, Typography, withWidth, isWidthDown } from "@material-ui/core";
import CountDown from '../CountDown/CountDown'
import { Cancel, Edit, Save } from '@material-ui/icons';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import TeamLogo from './TeamLogo';
import Seo from '../Seo/Seo';

class Home extends Component {

    state = {
        editBoilerplate: false,
        boilerplate: ''
    }

    componentDidMount() {
        this.getTeamDetails();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.team.boilerplate !== this.props.team.boilerplate &&
            !this.state.editBoilerplate
        ) {
            this.setState({ boilerplate: this.props.team.boilerplate || '' });
        }
    }

    getTeamDetails() {
        this.props.dispatch({
            type: 'FETCH_TEAM_DETAILS'
        })
    }

    toggleBoilerplateEdit = () => {
        if (!this.state.editBoilerplate) {
            this.setState({
                editBoilerplate: true,
                boilerplate: this.props.team.boilerplate || ''
            });
            return;
        }

        this.setState({
            editBoilerplate: false
        });
    }

    handleChangeFor = (propertyName) => (event) => {
        this.setState({

            [propertyName]: event.target.value

        });
    }

    handleBoilerplateSave = () => {
        this.props.dispatch({
            type: 'UPDATE_BOILERPLATE',
            payload: this.state
        })
        this.toggleBoilerplateEdit()
    }

    renderBoilerplateText = (text) => {
        if (!text) {
            return null;
        }

        const urlRegex = /https?:\/\/[^\s]+/g;
        const segments = [];
        let lastIndex = 0;

        for (const match of text.matchAll(urlRegex)) {
            const matchIndex = match.index ?? 0;
            if (matchIndex > lastIndex) {
                segments.push(text.slice(lastIndex, matchIndex));
            }
            segments.push(
                <a
                    key={`link-${matchIndex}`}
                    href={match[0]}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: this.props.user.color, textDecoration: "underline" }}
                >
                    {match[0]}
                </a>
            );
            lastIndex = matchIndex + match[0].length;
        }

        if (lastIndex < text.length) {
            segments.push(text.slice(lastIndex));
        }

        return segments.map((segment, index) => (
            <React.Fragment key={`segment-${index}`}>
                {segment}
            </React.Fragment>
        ));
    }

    render() {

        const { user, team, width } = this.props;
        const isMobile = isWidthDown('sm', width);
        const canEdit = user.clearance_id > 1;
        const showEditor = this.state.editBoilerplate && canEdit;
        const hasBoilerplate = Boolean(team.boilerplate && team.boilerplate.trim());

        return (
            <div style={{ marginTop: isMobile ? 56 : 80, padding: isMobile ? '16px 8px' : 30 }}>
                <Seo
                    title="Team Dashboard | Trivia Weekend"
                    description="Manage your trivia team's updates, current contest details, and shared notes from the Trivia Weekend dashboard."
                    canonicalPath="/#/home"
                    ogType="website"
                />
                <Typography
                    variant={isMobile ? "h5" : "h4"}
                    component="h1"
                    style={{ color: user.color, fontWeight: 700, marginBottom: 12, textAlign: isMobile ? 'center' : 'left' }}
                >
                    Trivia Weekend Team Dashboard
                </Typography>
                {/* Establish spacing between cards */}
                <br /><br />
                <CountDown />
                <Grid container spacing={isMobile ? 1 : 2} justify="center" style={{ marginTop: 6 }}>
                    <TeamLogo />
                    <Grid item xs={12} md={6}>
                        <Card
                            elevation={6}
                            style={{
                                backgroundColor: "#2f3238",
                                borderRadius: 16,
                                boxShadow: "0 16px 40px rgba(0, 0, 0, 0.3)"
                            }}
                        >
                            <CardContent>
                                <Typography
                                    align="center"
                                    variant="h6"
                                    style={{ color: user.color, fontWeight: 600, letterSpacing: 0.4 }}
                                >
                                    Team News
                                </Typography>
                                <Typography
                                    align="center"
                                    variant="body2"
                                    style={{ color: "#c5c9cf", marginTop: 6 }}
                                >
                                    Keep everyone in sync with a quick update.
                                </Typography>
                                <Divider style={{ backgroundColor: "rgba(255, 255, 255, 0.08)", margin: "16px 0" }} />
                                <Typography
                                    color="secondary"
                                    style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere", wordBreak: "break-word" }}
                                >
                                    {!showEditor && hasBoilerplate && this.renderBoilerplateText(team.boilerplate)}
                                    {!showEditor && !hasBoilerplate && (
                                        <span style={{ color: "#c5c9cf" }}>
                                            No team news yet. Share an update to get started.
                                        </span>
                                    )}
                                    {showEditor && (
                                        <TextField
                                            fullWidth
                                            multiline
                                            minRows={3}
                                            variant="outlined"
                                            value={this.state.boilerplate}
                                            onChange={this.handleChangeFor('boilerplate')}
                                            placeholder="What do you want your team to know?"
                                            helperText="Share a short update with your team."
                                            inputProps={{ 'aria-label': 'Team news update' }}
                                            FormHelperTextProps={{ style: { color: "#c5c9cf" } }}
                                            InputProps={{
                                                style: {
                                                    color: "#f5f7fa",
                                                    backgroundColor: "rgba(255, 255, 255, 0.06)"
                                                }
                                            }}
                                        />
                                    )}
                                </Typography>
                            </CardContent >
                            <CardActions style={{ padding: "8px 16px 16px", flexWrap: 'wrap', gap: 8 }}>
                                {!this.state.editBoilerplate && canEdit &&
                                    <Button
                                        color="secondary"
                                        variant="outlined"
                                        onClick={this.toggleBoilerplateEdit}
                                    >
                                        <Edit style={{ marginRight: 3 }} />Edit
                                    </Button>}
                                {this.state.editBoilerplate && canEdit &&
                                    <Button
                                        color="secondary"
                                        variant="outlined"
                                        onClick={this.toggleBoilerplateEdit}
                                    >
                                        <Cancel style={{ marginRight: 3 }} />Cancel
                                    </Button>}
                                {this.state.editBoilerplate && canEdit &&
                                    <Button
                                        onClick={this.handleBoilerplateSave}
                                        style={{
                                            marginLeft: "auto",
                                            marginRight: 0,
                                            color: user.color
                                        }}
                                    >
                                        <Save style={{ marginRight: 3 }} />Save
                                    </Button>}
                            </CardActions>
                        </Card >
                    </Grid >
                </Grid>
            </div >
        )
    }
}

const mapStateToProps = state => ({
    user: state.user,
    team: state.team
});

export default withRouter(connect(mapStateToProps)(withWidth()(Home)));
